



























import { Component, Prop, Vue } from 'vue-property-decorator';
import MiniCharacterList from '@/components/parts/MiniCharacterList.vue';
import KmyLogTagText from '@/components/parts/KmyLogTagText.vue';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from './../../api/api';
import * as def from '@/common/definitions';
import Enumerable from 'linq';
import CommandList from '../../models/status/commandlist';

@Component({
  components: {
    MiniCharacterList,
    KmyLogTagText,
    CharacterIcon,
  },
})
export default class UnitPicker extends Vue {
  @Prop() private units!: api.Unit[];
  @Prop() private value!: api.Unit;
  @Prop() private countries!: api.Country[];
  @Prop() private characters!: api.Character[];
  @Prop({
    default: () => undefined,
  }) private commands?: CommandList;
  @Prop({
    default: () => undefined,
  }) private otherCharacterCommands?: api.CharacterCommand[];

  private unitMemberCharacters(unit: api.Unit): api.Character[] {
    // 部隊のメンバの武将リスト
    return Enumerable.from(unit.members)
      .select((um) => um.character)
      .toArray();
  }

  private getCharacterNextTime(time: api.DateTime): api.DateTime {
    const dt = api.DateTime.toDate(time);
    dt.setSeconds(dt.getSeconds() + def.UPDATE_TIME);
    return api.DateTime.fromDate(dt);
  }

  private getCommandUniqueKey(cmd: api.CharacterCommand): number {
    if (cmd) {
      return api.GameDateTime.toNumber(cmd.gameDate);
    } else {
      return Math.random() * 1000;
    }
  }

  private getCharacterCommands(chara: api.Character): Array<(api.CharacterCommand | undefined)> {
    if (this.commands && this.otherCharacterCommands) {
      const startNumber = chara.lastUpdatedGameDate.year >= def.UPDATE_START_YEAR ?
        api.GameDateTime.toNumber(chara.lastUpdatedGameDate) + 1 :
        api.GameDateTime.toNumber(new api.GameDateTime(def.UPDATE_START_YEAR, 1));
      const endNumber = startNumber + 4;
      const cmds = Enumerable.from(this.otherCharacterCommands)
        .concat(this.commands.commands)
        .where((c) => c.characterId === chara.id)
        .where((c) => startNumber <= api.GameDateTime.toNumber(c.gameDate) &&
          api.GameDateTime.toNumber(c.gameDate) < endNumber);
      return [
        cmds.firstOrDefault((c) => api.GameDateTime.toNumber(c.gameDate) === startNumber),
        cmds.firstOrDefault((c) => api.GameDateTime.toNumber(c.gameDate) === startNumber + 1),
        cmds.firstOrDefault((c) => api.GameDateTime.toNumber(c.gameDate) === startNumber + 2),
        cmds.firstOrDefault((c) => api.GameDateTime.toNumber(c.gameDate) === startNumber + 3),
      ];
    } else if (chara.commands) {
      return chara.commands;
    }
    return [];
  }
}
